const onGeoLocate = ( ctx, event ) => {
    ctx.root.dispatchEvent( new CustomEvent( 'twc:collapse:collapse-all', { bubbles: true } ) );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:hide-remove-search-area', { bubbles: true } ) );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:draw-your-search:deactivate', {
        bubbles: true,
        detail: {
            search: false,
        },
    } ) );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:remove-area', {
        bubbles: true,
        detail: {
            search: false,
        },
    } ) );

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:search-this-area:deactivate', { bubbles: true } ) );

    ctx.userPosition = {
        lat: event.coords.latitude,
        lon: event.coords.longitude,
    };
};

const onGeoLocateTrigger = ( ctx, event ) => {
    if ( !ctx.geoLocate ) {
        return;
    }

    if ( document.querySelector( '#search-filter-popup.pagepopup__wrapper--open' ) ) {
        ctx.root.dispatchEvent( new CustomEvent( 'twc:search-popup-close', { bubbles: true } ) );
    }

    ctx.geoLocate.trigger();
};

export {
    onGeoLocate,
    onGeoLocateTrigger,
};
